"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHelper = exports.closeDialog = exports.showDialog = exports.launchDialog = exports.DialogWrapper = exports.DialogContext = exports.getIt = void 0;
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var CloseRounded_1 = __importDefault(require("@material-ui/icons/CloseRounded"));
var react_1 = __importStar(require("react"));
var Deferred_1 = require("../utils/Deferred");
var DialogHolder_1 = require("./DialogHolder");
var tsyringe_1 = require("tsyringe");
var __1 = require("..");
function getIt(token) {
    return tsyringe_1.container.resolve(token);
}
exports.getIt = getIt;
exports.DialogContext = react_1.default.createContext(undefined);
function DialogWrapper(props) {
    var _a = react_1.useState(true), open = _a[0], setOpen = _a[1];
    props.deferred.promise.then(function () { return setOpen(false); }).catch(function () { return setOpen(false); });
    return (react_1.default.createElement(Dialog_1.default, { fullScreen: props.fullScreen, open: open, onClose: function () { return props.deferred.reject(new Error("USER_CANCELLED")); }, scroll: "body", disableEscapeKeyDown: props.disableClose || false, disableBackdropClick: props.disableClose || false },
        react_1.default.createElement(exports.DialogContext.Provider, { value: props.deferred }, props.disableClose
            ? props.children
            : react_1.default.createElement(__1.APStack, null,
                react_1.default.createElement(__1.APAlign, { align: 'fill' }, props.children),
                react_1.default.createElement(__1.APAlign, { align: 'topLeft', style: { marginLeft: "12px", marginTop: "11px", zIndex: 1 } },
                    react_1.default.createElement(IconButton_1.default, { onClick: function () { return props.deferred.reject(new Error("USER_CANCELLED")); } },
                        react_1.default.createElement(CloseRounded_1.default, { htmlColor: "#8f8f8f" })))))));
}
exports.DialogWrapper = DialogWrapper;
function launchDialog(render, disableClose, fullScreen) {
    var deferred = new Deferred_1.Deferred();
    showDialog(react_1.default.createElement(DialogWrapper, { fullScreen: fullScreen, deferred: deferred, disableClose: disableClose !== null && disableClose !== void 0 ? disableClose : false }, render(deferred)));
    return deferred.promise;
}
exports.launchDialog = launchDialog;
function showDialog(cmp) {
    getIt(DialogHolder_1.DialogHolder).push(cmp);
    return function () { return getIt(DialogHolder_1.DialogHolder).pop(cmp); };
}
exports.showDialog = showDialog;
function closeDialog(cmp) {
    getIt(DialogHolder_1.DialogHolder).pop(cmp);
}
exports.closeDialog = closeDialog;
function DialogHelper() {
    var _a = react_1.useState({ cmps: new Array() }), state = _a[0], setState = _a[1];
    function onUpdate(cmps) {
        setState({ cmps: cmps });
    }
    react_1.useEffect(function () {
        getIt(DialogHolder_1.DialogHolder).setListener(onUpdate);
        return function () {
            getIt(DialogHolder_1.DialogHolder).removeListener();
        };
    }, []);
    return (react_1.default.createElement("div", { style: { minWidth: "280px" } }, state.cmps && state.cmps.map(function (cmp, index) { return react_1.default.createElement("div", { key: cmp.id }, cmp.element); })));
}
exports.DialogHelper = DialogHelper;
